import { toast } from "sonner";
import request from "../../../../helpers/request";
import { IUpdateConfigPtMonAnalogico } from "../types";

const DTO = (data: IUpdateConfigPtMonAnalogico) => {
  const {
    idLoja,
    idEquipamento,
    idGrupoMonitor,
    valor,
    escalaInf,
    escalaSup,
    limiteSup,
    limiteInf,
    toleranciaValor,
    toleranciaTime,
    coordX,
    coordY,
    offSet,
    calibracaoEscala,
    hrMsgEscaladaNV2,
    minMsgEscaladaNV2,
    hrMsgEscaladaNV3,
    minMsgEscaladaNV3,
  } = data;

  const checkDataEscalada = (data) => (!data ? "00" : data);

  return {
    ...data,
    idLoja: Number(idLoja),
    idEquipamento: Number(idEquipamento),
    idGrupoMonitor: Number(idGrupoMonitor),
    valor: Number(valor),
    escalaInf: Number(escalaInf),
    escalaSup: Number(escalaSup),
    limiteSup: Number(limiteSup),
    limiteInf: Number(limiteInf),
    toleranciaValor: Number(toleranciaValor),
    toleranciaTime: Number(toleranciaTime),
    coordX: Number(coordX),
    coordY: Number(coordY),
    offSet: Number(offSet),
    calibracaoEscala: Number(calibracaoEscala),
    timeMsgEscaladaNV2: `${checkDataEscalada(
      hrMsgEscaladaNV2,
    )}:${checkDataEscalada(minMsgEscaladaNV2)}`,
    timeMsgEscaladaNV3: `${checkDataEscalada(
      hrMsgEscaladaNV3,
    )}:${checkDataEscalada(minMsgEscaladaNV3)}`,
    msgFalhaAcimaCustom: "",
    msgFalhaAbaixoCustom: "",
    msgNormalCustom: "",
  };
};

console.log("DTO", DTO);

export const updateConfigPtMonAnalogico = async (
  idPt: string,
  props: IUpdateConfigPtMonAnalogico,
) => {
  try {
    const url = `${process.env.REACT_APP_API}/MonAnalogico/${idPt}`;
    const data = DTO({
      ...props,
    });
    const result = await request({
      url,
      method: "put",
      data,
      headers: { "Content-Type": "application/json" },
    });

    console.log("result updateConfigPtMonAnalogico", result);

    if (result.data.toLowerCase() === "ok") {
      toast.success("Configuração atualizada com sucesso");
      return result.data;
    } else {
      throw new Error(result.data);
    }
  } catch (error: any) {
    const mensagemApi =
      error?.response?.data?.message ??
      error?.response?.data ??
      error?.message;

    toast.error(
      typeof mensagemApi === "string" && mensagemApi.trim()
        ? mensagemApi
        : "Houve um erro ao atualizar configuração!",
    );
  }
};
